import { genreOptions, regionOptions, yearOptions } from "@/mocks/anime";

interface FilterPanelProps {
  selectedGenres: string[];
  selectedRegions: string[];
  selectedYears: string[];
  onToggleGenre: (value: string) => void;
  onToggleRegion: (value: string) => void;
  onToggleYear: (value: string) => void;
  onClear: () => void;
}

function ChipGroup({
  title,
  options,
  selected,
  onToggle,
}: {
  title: string;
  options: { value: string; label: string }[];
  selected: string[];
  onToggle: (value: string) => void;
}) {
  return (
    <div>
      <h4 className="mb-3 text-sm font-semibold text-foreground-900">{title}</h4>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = selected.includes(option.value);
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onToggle(option.value)}
              aria-pressed={active}
              className={`whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${
                active
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({
  selectedGenres,
  selectedRegions,
  selectedYears,
  onToggleGenre,
  onToggleRegion,
  onToggleYear,
  onClear,
}: FilterPanelProps) {
  const hasFilter =
    selectedGenres.length > 0 || selectedRegions.length > 0 || selectedYears.length > 0;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-primary-600" />
          筛选条件
        </h3>
        <button
          type="button"
          onClick={onClear}
          disabled={!hasFilter}
          className={`flex items-center gap-1 whitespace-nowrap text-xs font-medium transition-colors ${
            hasFilter ? "text-accent-700 hover:text-accent-800" : "text-foreground-300"
          }`}
        >
          <i className="ri-refresh-line" />
          清空
        </button>
      </div>

      <ChipGroup
        title="类型"
        options={genreOptions.map((g) => ({ value: g, label: g }))}
        selected={selectedGenres}
        onToggle={onToggleGenre}
      />
      <div className="h-px bg-background-200" />
      <ChipGroup
        title="地区"
        options={regionOptions.map((r) => ({ value: r, label: r }))}
        selected={selectedRegions}
        onToggle={onToggleRegion}
      />
      <div className="h-px bg-background-200" />
      <ChipGroup
        title="年份"
        options={yearOptions.map((y) => ({ value: String(y), label: `${y} 年` }))}
        selected={selectedYears}
        onToggle={onToggleYear}
      />
    </div>
  );
}